import React, { useEffect, useRef, useState } from "react";
import { Autocomplete, Button, FormControl, TextField } from "@mui/material";
import { Box, Flex } from "@100mslive/roomkit-react";
import { Cross } from "../../../icons";
import FullPageProgress from "../../FullPageProgress";
import { ToastManager } from "../../Toast/ToastManager";
import { SESSION_AUTH } from "../../../common/auth";
import { EXCHANGE_SERVICES } from "../../../services";

const AccountStockAddPopup = props => {
  const { onClose, onUpdate } = props;
  const { isUserSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const [loading, setLoading] = useState(false);
  const dataFetched = useRef(false);
  const [exchangeList, setExchangeList] = useState([]);
  const [symbolList, setSymbolList] = useState([]);

  const [exchange, setExchange] = useState("");
  const [symbol, setSymbol] = useState("");
  const [exSystem, setExSystem] = useState("");
  const [currency, setCurrency] = useState("");
  const [country, setCountry] = useState("");

  useEffect(() => {
    if (dataFetched?.current) return;
    dataFetched.current = true;
    EXCHANGE_SERVICES.list({
      userId: isUserSession.userId,
      org: isUserSession?.org?.id,
    })
      .then(data => {
        if (data.code === 200) {
          setExchangeList(data.data);
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
          onClose();
        }
      })
      .catch(err => {
        ToastManager.addToast({
          title: err?.message,
        });
        onClose();
      });
  }, [isUserSession, LOGOUT_USER_SESSION, onClose]);

  const getSymbols = list => {
    setExchange(list?.code);
    setExSystem(list?.exSystem);
    setCountry(list?.country);
    setSymbol("");
    setCurrency("");
    setSymbolList([]);

    if (list?.code) {
      setLoading(true);
      EXCHANGE_SERVICES.symbolList({
        userId: isUserSession.userId,
        org: isUserSession?.org?.id,
        exchange: list?.code,
      })
        .then(data => {
          if (data.code === 200) {
            setSymbolList(data.data);
          } else if (data.code === 600) {
            LOGOUT_USER_SESSION();
          } else {
            ToastManager.addToast({ title: data.message });
          }
        })
        .catch(err => {
          ToastManager.addToast({
            title: err?.message,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const onSave = () => {
    if (!exchange) {
      return ToastManager.addToast({
        title: "Please select stock exchange",
      });
    }

    if (!symbol) {
      return ToastManager.addToast({
        title: "Please select exchange symbol",
      });
    }

    setLoading(true);
    EXCHANGE_SERVICES.stockSave({
      userId: isUserSession.userId,
      org: isUserSession?.org?.id,
      exchange: exchange,
      symbol: symbol,
      exSystem: exSystem,
      currency: currency,
      country: country,
    })
      .then(data => {
        if (data.code === 200) {
          onUpdate();
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({
          title: err?.message,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return exchangeList?.length > 0 ? (
    <Flex
      align="center"
      direction="column"
      className="eventsPopup eventsPopup-sm"
      onClick={() => {
        onClose(false);
      }}
    >
      <Box
        className="eventsPopup-inner"
        onClick={e => {
          e.stopPropagation();
        }}
      >
        {loading && <FullPageProgress fixed={true} />}
        <div
          className="eventsPopup-close"
          onClick={() => {
            onClose(false);
          }}
        >
          <Cross />
        </div>
        <div className="eventsPopup-header">
          <div className="eventsPopup-header-heading">Add stock</div>
        </div>
        <div className="eventsPopup-content">
          <Flex direction="column" css={{ gap: "20px" }}>
            <FormControl className="custom-form-group">
              <Autocomplete
                disablePortal
                options={exchangeList}
                getOptionLabel={option =>
                  `${option.code} ${
                    option.country ? "(" + option.country + ")" : ""
                  }`
                }
                value={exchangeList.find(e => e.code === exchange) || null}
                onChange={(event, newValue) => {
                  getSymbols(newValue);
                }}
                className="custom-select custom-select-h-auto"
                renderInput={params => (
                  <TextField {...params} placeholder="Select Exchange" />
                )}
              />
            </FormControl>

            {exchange ? (
              <FormControl className="custom-form-group">
                <Autocomplete
                  disablePortal
                  options={symbolList}
                  getOptionLabel={option => `${option.code}`}
                  value={symbolList.find(e => e.code === symbol) || null}
                  onChange={(event, newValue) => {
                    setSymbol(newValue?.code);
                    setCurrency(newValue?.currency);
                  }}
                  className="custom-select custom-select-h-auto"
                  renderInput={params => (
                    <TextField {...params} placeholder="Select Symbol" />
                  )}
                />
              </FormControl>
            ) : null}
          </Flex>

          <div className="events-page-account-setting-content-box-line"></div>
          <Flex align="center" justify="center">
            <Button
              color="primary"
              variant="outlined"
              className="events6ix-btn events6ix-btn-primary"
              type="button"
              onClick={onSave}
            >
              ADD Stock
            </Button>
          </Flex>
        </div>
      </Box>
    </Flex>
  ) : (
    <FullPageProgress fixed={true} />
  );
};

export default AccountStockAddPopup;
